import { RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS } from '../RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS';
import { RelationshipRoleCompatibilityOptionIdType } from '../types';

export const getRelationshipRoleCompatibilityTitleById = (
  id: RelationshipRoleCompatibilityOptionIdType | null,
): string | null => {
  if (!id) return null;
  return (
    RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS.find((option) => option.id === id)
      ?.title || null
  );
};

const DEFAULT: RelationshipRoleCompatibilityOptionIdType = 'equal';
export const getRelationshipRoleCompatibilityIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): RelationshipRoleCompatibilityOptionIdType | null => {
  const id = RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
